export default "__VITE_ASSET__C5lV2qIw__"